type Decision = { message: string; resolve: (accepted: boolean) => void };
type Pending = { id: number; label: string; timer: ReturnType<typeof setTimeout> };
let decisions = $state<Decision[]>([]);
let pending = $state<Pending[]>([]);
let nextId = 0;

export function confirmAction(message: string, signal?: AbortSignal): Promise<boolean> {
  return new Promise(resolve => {
    if(signal?.aborted){resolve(false);return;}
    const decision:Decision={message,resolve(accepted){signal?.removeEventListener('abort',cancel);resolve(accepted);}};
    const cancel=()=>{decisions=decisions.filter(row=>row!==decision);decision.resolve(false);};
    signal?.addEventListener('abort',cancel,{once:true});
    decisions = [...decisions,decision];
  });
}

// Delay the actual request, rather than claiming a destructive API call can be
// reversed. Unloading the document before the timer runs cancels it naturally.
export function scheduleUndo(label: string, action: () => void): void {
  if (pending.some(item => item.label === label)) return;
  const id = ++nextId;
  const timer = setTimeout(() => {
    pending = pending.filter(item => item.id !== id);
    action();
  }, 5000);
  pending = [...pending, { id, label, timer }];
}

export const actionDialog = {
  get current() { return decisions[0]; },
  get pending() { return pending; },
  decide(accepted: boolean) {
    const decision = decisions[0];
    decisions = decisions.slice(1);
    decision?.resolve(accepted);
  },
  undo(id: number) {
    const item = pending.find(item => item.id === id);
    if (item) clearTimeout(item.timer);
    pending = pending.filter(item => item.id !== id);
  },
  cancelAll() {
    for (const item of pending) clearTimeout(item.timer);
    pending = [];
    for (const decision of decisions) decision.resolve(false);
    decisions = [];
  }
};
